import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './Spacer.css';


const Spacer = ({ className, id, }) => <div id={id} className={cx(s.component, className)}></div>;

Spacer.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired
};

export default Spacer;



// WEBPACK FOOTER //
// ./src/components/FormElements/Spacer/Spacer.js